module.exports = __webpack_public_path__ + "img/clothing49.b0cca203.jpg";